import { Outlet } from "react-router";
import InstallPrompt from "../components/InstallPrompt";
import Navbar from "../components/Navbar";
import styles from "./AuthLayout.module.css";

const AuthLayout = () => {
  return (
    <div className={styles.layout}>
      <Outlet />
      <Navbar />
      <InstallPrompt />
    </div>
  );
};

export default AuthLayout;
